import React from 'react';

import { Alert, Button, Stack } from '@mui/material';

import { toPromoBrand } from '~/consts/promoBrand';

import { useGetMyVouchersCount } from '~/hooks/apis/promo/useGetMyVouchers';

import isUUID from '~/utils/isUUID';

type Props = {
  brand: string;
  userId: string;
};

export default function ExistingActiveVouchersButton({ brand, userId }: Props) {
  const normalizedUserId = userId.trim();
  const promoBrand = toPromoBrand(brand);
  const { data, error, isFetching, refetch } = useGetMyVouchersCount(
    { brand: promoBrand, overrideUserId: normalizedUserId },
    { enabled: Boolean(promoBrand) && isUUID(normalizedUserId) },
  );
  const search = new URLSearchParams({
    user_id: normalizedUserId,
    include_expired: 'false',
    include_used: 'false',
    only_used: 'false',
  });

  return (
    <Stack spacing={1} alignItems="flex-start">
      {data && (
        <Button
          variant="text"
          color="primary"
          href={`/marketing/vouchers?${search.toString()}#voucher-users`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.result.count} existing active vouchers
        </Button>
      )}
      {isFetching && !data && <Button disabled>Loading existing active vouchers…</Button>}
      {error && (
        <Alert
          severity="error"
          action={
            <Button onClick={() => void refetch()} disabled={isFetching}>
              Retry
            </Button>
          }
        >
          Unable to load existing active vouchers: {error.message}
        </Alert>
      )}
    </Stack>
  );
}
